import React from 'react'
import "./HCategory.css"
import HCategoryData from './HCategoryData'
import HCategoryCard from './HCategoryCard'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';

const HCategory = () => {
    const navigate = useNavigate();

    return (
        <div className='HCategory'>
            <div className='HCategory-main'>
                <div className="HCategory-head">
                    <h2>SPORTS SCIENCE & RESEARCH </h2>
                    {/* <p>Critical care to mobile health, BPL is the preferred choice for total solutions across specialties.</p> */}
                </div>
                <div className='HCategory-box'>
                    {/* <Swiper
                        className="mySwiper"
                        slidesPerView={4}
                        spaceBetween={20}
                        loop={true}
                        speed={1000}
                        navigation={true}
                        modules={[Autoplay, Navigation]}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            480: {
                                slidesPerView: 2,
                                spaceBetween: 15,
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 4,
                                spaceBetween: 20,
                            },
                        }}
                    >
                        {HCategoryData.map((item) => (
                            <SwiperSlide key={item.id}>
                                <HCategoryCard item={item} navigate={navigate} />
                            </SwiperSlide>
                        ))}
                    </Swiper> */}
                    <div className='HCategory-box'>
                        <Swiper
                            className="mySwiper"
                            slidesPerView={4}
                            spaceBetween={20}
                            loop={true}
                            speed={1000}
                            navigation={true}
                            autoplay={{
                                delay: 1000, 
                                disableOnInteraction: false,
                            }}
                            modules={[Autoplay, Navigation]}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                480: {
                                    slidesPerView: 2,
                                    spaceBetween: 15,
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                1024: {
                                    slidesPerView: 4,
                                    spaceBetween: 20,
                                },
                            }}
                        >
                            {HCategoryData.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <HCategoryCard item={item} navigate={navigate} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default HCategory;
